import React, { useState, useEffect, useContext } from "react";
import StepWizard from "react-step-wizard";
import useRequest from "../../../../hooks/useRequest";
import { customFetch } from "../../../../hooks/customFetch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import tr from "date-fns/locale/tr";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import useAppContext from "../../../../context/useAppContext";
import { StepContextProvider, useWizardContext } from "../../../stepProvider";
import useGtmEvent from "../../../../hooks/useGtmEvent";

const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");

const Step1 = (props) => {
  const wizardContext = useWizardContext();
  const { innerTexts, tc, token, slugify } = useAppContext();

  registerLocale("tr", tr);

  const Part1 = (props) => {
    const [danger, setDanger] = useState({ valid: false, message: "" });
    const { startFetch, response, loading, startFetchFormData } = useRequest();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState(""); // const [birthday, setBirthday] = useState("");
    const [gender, setGender] = useState(null);
    const [relationState, setRelationState] = useState(null);
    const [birthday, setBirthday] = useState();
    const [idSerialNu, setIdSerialNu] = useState("");
    const [tipVisible, setTipVisible] = useState(false);
    const [firstCheckDone, setFirstCheckDone] = useState(false);
    const [birthplace, setBirthPlace] = useState("");

    const [pickBranch, setPickBranch] = useState("");
    const [branchList, setBranchList] = useState([]);

    useEffect(() => {
      if (response) {
        if (response.errNo === 0) {
          
          if (response.tc_no_check === "false") {
            return;
          }

          if (response.bilgiler) {
            var data = { ...response.bilgiler };
            setName(data.ad);
            setLastname(data.soyad);
            setBirthPlace(data.dogum_yeri);
            sessionStorage.setItem("first_name", slugify(data.ad));
            sessionStorage.setItem("last_name", slugify(data.soyad));
  
            if (data.dogum_tarihi !== "") {
              sessionStorage.setItem("bd", data.dogum_tarihi);
              let birthDateArr = data.dogum_tarihi.split("-");
              var dobj = new Date(
                parseInt(birthDateArr[0]),
                parseInt(birthDateArr[1]) - 1,
                parseInt(birthDateArr[2])
              );
              setBirthday(dobj);
            }

            setGender(data.cinsiyet);
            setRelationState(data.medeni_durum);
            setIdSerialNu(data.kimlik_serino);
          } else if (response.subeler) {
            setBranchList(response.subeler);
          }
        }
      }
    }, [response]);

    useEffect(() => {
      startFetch("islem=kimlik_bilgileri_getir&step=1", "GET");
    }, []);

    useEffect(() => {
      if (innerTexts.id === "INFOYATIRIM") {
        startFetch("islem=subeler", "GET");

        customFetch({
          params: `islem=yatirimci_bilgileri_getir`,
          method: "GET",
          contentType: null,
          body: null,
          token: token,
          onSuccess: (res) => {
            if (res.errNo === 0) {
              if (res.bilgiler.sube) {
                setPickBranch(res.bilgiler.sube);
              }
            }
          },
        });
      }
    }, []);

    const Part1Validation = async () => {
      if (
        name === "" ||
        lastname === "" ||
        birthday === "" ||
        (innerTexts.gender && gender === "") ||
        (innerTexts.id === "GALATA" && relationState === "") ||
        (innerTexts.addresVerify && innerTexts.id !== 'ISTANBULPORTFOY' && innerTexts.id !== 'HEDEF' && idSerialNu === "") ||
        ((innerTexts.id === "DINAMIK") && birthplace === "")
      ) {
        setDanger({
          valid: true,
          message: innerTexts.error_messages_empty_tckn,
        });
        return false;
      } else {
        return new Promise((resolve) => {
          startFetchFormData(
            "islem=tc_no_check",
            {
              tc_no: tc,
              ad: name,
              soyad: lastname,
              dogum_yili: birthday?.toString().split(" ")[3],
              medeni_durumu: relationState,
              dogum_yeri: birthplace,
              cinsiyet: innerTexts.gender ? gender || "E" : "E",
            },
            {
              queryParams: {},
              useSetter: false,
            },
            (data) => {
              if (data.tc_no_check === "true") {
                setDanger({ valid: false, message: "" });
                resolve(true);
              } else {
                setDanger({
                  valid: true,
                  message: innerTexts.error_messages_wrong_tckn,
                });
                resolve(false);
              }
            }
          );
        });
      }
    };

    const saveForm = async () => {
      if (isSubmitting) return;
      setIsSubmitting(true);

      var errorElement = window.jQuery("html");
      var scrollPosition = errorElement.offset().top - 25;
      window.jQuery('html, body').animate({ scrollTop: scrollPosition }, 500);

      setFirstCheckDone(false);
      let birthDate =
        birthday?.getFullYear() +
        "-" +
        (birthday?.getMonth() + 1) +
        "-" +
        birthday?.getDate();
      var model = {
        ad: slugify(name),
        soyad: slugify(lastname),
        cinsiyet: gender || "E",
        dogum_tarihi: birthDate,
        medeni_durumu: relationState,
        dogum_yeri: birthplace,
      };
      if (innerTexts.id === "DINAMIK") {
        model.dogum_yeri = birthplace;
      }
      if (innerTexts.id === "DESTEK" && process.env.NODE_ENV != "development") {
        model.kurum = "DESTEK";
      }
      var params = "";
      for (var I in model) {
        params += "" + I + "=" + model[I] + "&";
      }

      if (await Part1Validation()) {
        startFetchFormData(
          "islem=kimlik_bilgileri",
          model,
          {
            queryParams: {
              step: 1,
            },
            useSetter: false,
          },
          (res) => {
            if(res.errNo !== 0) {
              setDanger({
                valid: true,
                message: res.errDesc,
              });
              setIsSubmitting(false);
              return;
            }
            
            if (res.errNo === 0) {
              setFirstCheckDone(true);

              // temp for isy
              if (innerTexts.id === "ISTANBULPORTFOY") {
                wizardContext.ileri();
                return;
              }

              if (innerTexts.id === "INFOYATIRIM") {
                if (innerTexts.branch) {
                  if (pickBranch === "") {
                    setIsSubmitting(false);
                    return setDanger({
                      message: innerTexts.error_messages_step_one_episode,
                      valid: true,
                    });
                  }
                }
                setDanger({ valid: false, message: "" });
                startFetchFormData(
                  "islem=yatirimci_bilgileri_diger",
                  {
                    sube: pickBranch,
                  },
                  {
                    queryParams: {},
                  },
                );
              }
            }
            sessionStorage.setItem("first_name", name);
            sessionStorage.setItem("last_name", lastname);
            if (
              innerTexts.addresVerify &&
              innerTexts.id !== "ISTANBULPORTFOY" &&
              innerTexts.id !== "HEDEF" &&
              res.errNo === 0
            ) {
              startFetchFormData(
                "islem=kimlik_bilgileri_diger",
                {
                  kimlik_serino: idSerialNu,
                },
                {
                  queryParams: {
                    step: 1,
                  },
                  useSetter: false,
                },
                (res2) => {
                  if (res2.errNo !== 0) {
                    setDanger({ valid: true, message: res2.errDesc });
                    setIsSubmitting(false);
                    return;
                  }

                  if (innerTexts.id === "OSMANLIYATIRIM") {
                    props.handleWizard.goToStep(3);
                  }
                  props.portfoy ? props.nextStep() : wizardContext.ileri();
                },
              );
              return;
            }

            if (innerTexts.id === "OSMANLIYATIRIM") {
              props.handleWizard.goToStep(3);
            }
            props.portfoy ? props.nextStep() : wizardContext.ileri();
          },
        );
        sessionStorage.setItem("bd", birthDate);
      } else {
        setIsSubmitting(false);
      }
    };

    const maxDateFor18Plus = new Date();
    maxDateFor18Plus.setFullYear(maxDateFor18Plus.getFullYear() - 18);

    return (
      <>
        <div className="col-md-12">
          <div
            className="col-md-12"
            style={{ textAlign: "center", marginBottom: 20 }}
          >
            <h2>{innerTexts.label_step_one}</h2>
            <p
              dangerouslySetInnerHTML={{
                __html: innerTexts.id !== "OSMANLIYATIRIM" ? innerTexts.label_step_one_description_html : innerTexts.label_step_one_warning_html,
              }}
            ></p>
          </div>
        </div>
        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {" "}
                {innerTexts.label_step_one_input_name}
              </label>
            </div>
            <input
              onChange={(e) => {
                if (
                  e.target.value.charCodeAt(e.target.value.length - 1) ===
                    105 ||
                  e.target.value.charCodeAt(e.target.value.length - 1) === 304
                ) {
                  e.target.value =
                    e.target.value.slice(0, e.target.value.length - 1) + "İ";
                  setName(e.target.value.toLocaleUpperCase());
                } else {
                  setName(e.target.value.toLocaleUpperCase());
                }
              }}
              value={name.toLocaleUpperCase()}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="text"
              required="required"
              className="form-control"
              placeholder=""
            />
          </div>
        </div>
        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_lastname}
              </label>
            </div>
            <input
              onChange={(e) => {
                if (
                  e.target.value.charCodeAt(e.target.value.length - 1) ===
                    105 ||
                  e.target.value.charCodeAt(e.target.value.length - 1) === 304
                ) {
                  e.target.value =
                    e.target.value.slice(0, e.target.value.length - 1) + "İ";
                  setLastname(e.target.value.toLocaleUpperCase());
                } else {
                  setLastname(e.target.value.toLocaleUpperCase());
                }
              }}
              value={lastname.toLocaleUpperCase()}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="text"
              required="required"
              className="form-control"
              placeholder=""
            />
          </div>
        </div>
        {innerTexts?.gender && (
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div className="input-group-prepend">
                <label className="control-label">
                  {innerTexts.label_step_one_input_gender}
                </label>
              </div>
              <select
                className="form-control"
                value={gender}
                placeholder="Seçiniz"
                onChange={(e) => {
                  setGender(e.target.value);
                }}
              >
                <option disabled value="">
                  Seçiniz
                </option>
                <option value="E">Erkek</option>
                <option value="B">Kadın</option>
              </select>
            </div>
          </div>
        )}
        {innerTexts.id === "GALATA" && (
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div className="input-group-prepend">
                <label className="control-label">
                  {innerTexts.label_step_one_input_relation_state}
                </label>
              </div>
              <select
                className="form-control"
                value={relationState}
                defaultValue={relationState}
                onChange={(e) => {
                  setRelationState(e.target.value);
                }}
              >
                <option disabled value="">
                  Seçiniz
                </option>
                <option value="E">EVLİ</option>
                <option value="B">BEKAR</option>
                <option value="D">DUL</option>
              </select>
            </div>
          </div>
        )}
        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_birthday}
              </label>
            </div>
            {/* <input
              onChange={(e) => {
                setBirthday(e.target.value);
              }}
              defaultValue={birthday}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="date"
              required="required"
              className="form-control"
              placeholder=""
            /> */}
            <DatePicker
              maxDate={innerTexts.id === 'AHLATCI' ? maxDateFor18Plus : new Date(2050, 1, 29)}
              wrapperClassName="birthDateInput"
              required="required"
              className="form-control"
              showYearDropdown
              yearDropdownItemNumber={80}
              scrollableYearDropdown
              selected={birthday}
              onChange={(date) => {
                setBirthday(date);
              }}
              locale="tr"
              dateFormat="dd-MM-yyyy"
              placeholderText="gün-ay-yıl"
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={[
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  keepCharPositions={true}
                  guide={true}
                />
              }
            />
          </div>
        </div>
        {innerTexts.id === "INFOYATIRIM" && (
          <div className="col-md-12">
            <div
              style={{ display: "block", zIndex: 2 }}
              className="input-group input-group-lg lg-12"
            >
              <div className="input-group-prepend">
                <label className="control-label">
                  {" "}
                  {innerTexts.label_pickup_branch}
                </label>
              </div>
              <div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setPickBranch(e.target.value);
                  }}
                  value={pickBranch}
                >
                  <option value="">Seçiniz</option>

                  {branchList &&
                    branchList.map((item) => (
                      <option value={item.key}>{item.value}</option>
                    ))}
                </select>
              </div>
            </div>
          </div>
        )}

        {innerTexts.id === "DINAMIK" && (
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div className="input-group-prepend">
                <label className="control-label">
                  {innerTexts.label_step_one_input_birthplace}
                </label>
              </div>
              <input
                onChange={(e) => {
                  if (
                    e.target.value.charCodeAt(e.target.value.length - 1) ===
                      105 ||
                    e.target.value.charCodeAt(e.target.value.length - 1) === 304
                  ) {
                    e.target.value =
                      e.target.value.slice(0, e.target.value.length - 1) + "İ";
                    setBirthPlace(e.target.value.toLocaleUpperCase());
                  } else {
                    setBirthPlace(e.target.value.toLocaleUpperCase());
                  }
                }}
                defaultValue={birthplace}
                value={birthplace}
                aria-describedby="inputGroup-sizing-lg"
                maxLength="100"
                type="text"
                required="required"
                className="form-control"
                placeholder=""
              />
            </div>
          </div>
        )}
        {innerTexts.addresVerify && innerTexts.id !== 'ISTANBULPORTFOY' && innerTexts.id !== 'HEDEF' && (
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div
                className="serialnu-tip"
                style={{ visibility: tipVisible ? "visible" : "hidden" }}
              >
                {
                  innerTexts.id === 'INVESTAZ' ? (
                    <>
                      <h6>Yeni tip kimlik kartlarında seri numarası formatı A12A12345</h6>
                    </>
                  ) : (
                    <>
                      <h6>Yeni tip kimlik kartlarında seri nu formatı: A12345678</h6>
                      <h6>Eski tip kimlik kartlarında seri nu formatı: A12A12345</h6>
                    </>
                  )
                }
              </div>
              <div
                className="input-group-prepend"
                onClick={() => setTipVisible(!tipVisible)}
              >
                <span
                  className="input-group-text"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "help",
                  }}
                >
                  <i className="fa fa-question-circle fa-lg text-danger"></i>
                </span>
                <label className="control-label">
                  {innerTexts.label_step_one_input_id_serial_nu}
                </label>
              </div>
              <input
                onChange={(e) => {
                  if (
                    e.target.value.charCodeAt(e.target.value.length - 1) ===
                      105 ||
                    e.target.value.charCodeAt(e.target.value.length - 1) === 304
                  ) {
                    e.target.value =
                      e.target.value.slice(0, e.target.value.length - 1) + "İ";
                    setIdSerialNu(e.target.value.toLocaleUpperCase());
                  } else {
                    setIdSerialNu(e.target.value.toLocaleUpperCase());
                  }
                }}
                defaultValue={idSerialNu}
                value={idSerialNu}
                aria-describedby="inputGroup-sizing-lg"
                maxLength="9"
                type="text"
                required="required"
                className="form-control"
                placeholder="Kimlik Seri No"
              />
            </div>
          </div>
        )}
        <div className="col-md-12">
          {danger.valid ? (
            <div
              style={{ marginTop: 10 }}
              className="alert alert-danger"
              role="alert"
            >
              {danger.message}
            </div>
          ) : (
            void 0
          )}
        </div>
        <div className="col-md-12">
          <button
            style={{
              marginTop: 20,
              filter: (loading || isSubmitting) ? "brightness(120%)" : "",
              cursor: (loading || isSubmitting) ? "no-drop" : "pointer",
            }}
            onClick={() => {
              saveForm();
            }}
            className="btn btn-primary nextBtn pull-right btn-block btn-lg"
            disabled={loading || isSubmitting}
            type="button"
          >
            {(loading || isSubmitting) ? "Yükleniyor..." : innerTexts.btn_text_step_one}
          </button>
        </div>
      </>
    );
  };

  const Part2 = (props) => {
    const [danger, setDanger] = useState({ valid: false, message: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [birthplace, setBirthPlace] = useState("");
    const [fatherName, setFatherName] = useState("");
    const [relationState, setRelationState] = useState("");
    const [motherName, setMotherName] = useState("");
    const [nationality, setNationality] = useState("Türk");
    const [idSerialNu, setIdSerialNu] = useState("");
    const [tipVisible, setTipVisible] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        setTipVisible(false);
      }, 5000);
    }, [tipVisible]);

    const { startFetch, response, loading, startFetchFormData } = useRequest();

    const saveForm = async () => {
      if (isSubmitting) return;
      setIsSubmitting(true);

      var errorElement = window.jQuery("html");
      var scrollPosition = errorElement.offset().top - 25;
      window.jQuery('html, body').animate({ scrollTop: scrollPosition }, 500);

      if (Part2Validation()) {
        startFetchFormData(
          `islem=${innerTexts.id === "ISTANBULPORTFOY" || innerTexts.id === "HEDEF" ? "kimlik_bilgileri_diger" : "kimlik_bilgileri"}`,
          {
            dogum_yeri: birthplace,
            baba_adi: fatherName,
            anne_adi: motherName,
            medeni_durumu: relationState,
            uyruk_bilgisi: nationality,
            ...(innerTexts.id !== "OPTIMUS" && { kimlik_serino: idSerialNu }),
          },
          {
            queryParams: {
              step: 1,
            },
            useSetter: false,
          },
          (res) => {
            setIsSubmitting(false);
            if(res.errNo !== 0) {
              setDanger({
                valid: true,
                message: res.errDesc,
              });
              return;
            }

          },
        );
      } else {
        setIsSubmitting(false);
      }
    };
    const Part2Validation = () => {
      if (
        fatherName === "" ||
        birthplace === "" ||
        relationState === "" ||
        motherName === "" ||
        nationality === "" ||
        (innerTexts.id !== "OPTIMUS" && innerTexts.addresVerify && idSerialNu === "")
      ) {
        setDanger({
          valid: true,
          message: innerTexts.error_messages_empty_tckn,
        });
        return false;
      }
      return true;
    };
    useEffect(() => {
      startFetch("islem=kimlik_bilgileri_getir&step=1", "GET");
    }, []);

    useEffect(() => {
      if (innerTexts.id === "INFOYATIRIM") {
        window.gtag("config", "AW-468162055");
        window.gtag("event", "conversion", {
          send_to: "AW-468162055/SVYECP27s8MDEIesnt8B",
        });
      }
    }, []);

    useEffect(() => {
      if (response) {
        if (response.errNo === 0) {
          if (response.bilgiler) {
            var data = { ...response.bilgiler };
            setBirthPlace(data.dogum_yeri);
            setFatherName(data.baba_adi);
            setRelationState(data.medeni_durum);
            setMotherName(data.anne_adi);
            if (innerTexts.id !== "OPTIMUS") {
              setIdSerialNu(data.kimlik_serino);
            }
            // setNationality(data.uyruk_bilgisi)
          } else {
            if (
              innerTexts.id === "OSMANLIYATIRIM" ||
              innerTexts.id === "ISIKMENKUL"
            ) {
              props.handleWizard.goToStep(3);
            }
            wizardContext.ileri();
          }
        }
      }
    }, [response]);
    return (
      <>
        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_birthplace}
              </label>
            </div>
            <input
              onChange={(e) => {
                if (
                  e.target.value.charCodeAt(e.target.value.length - 1) ===
                    105 ||
                  e.target.value.charCodeAt(e.target.value.length - 1) === 304
                ) {
                  e.target.value =
                    e.target.value.slice(0, e.target.value.length - 1) + "İ";
                  setBirthPlace(e.target.value.toLocaleUpperCase());
                } else {
                  setBirthPlace(e.target.value.toLocaleUpperCase());
                }
              }}
              defaultValue={birthplace}
              value={birthplace}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="text"
              required="required"
              className="form-control"
              placeholder=""
            />
          </div>
        </div>

        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_father_name}
              </label>
            </div>
            <input
              onChange={(e) => {
                if (
                  e.target.value.charCodeAt(e.target.value.length - 1) ===
                    105 ||
                  e.target.value.charCodeAt(e.target.value.length - 1) === 304
                ) {
                  e.target.value =
                    e.target.value.slice(0, e.target.value.length - 1) + "İ";
                  setFatherName(e.target.value.toLocaleUpperCase());
                } else {
                  setFatherName(e.target.value.toLocaleUpperCase());
                }
              }}
              defaultValue={fatherName}
              value={fatherName}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="text"
              required="required"
              className="form-control"
              placeholder=""
            />
          </div>
        </div>

        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_mother_name}
              </label>
            </div>
            <input
              onChange={(e) => {
                if (
                  e.target.value.charCodeAt(e.target.value.length - 1) ===
                    105 ||
                  e.target.value.charCodeAt(e.target.value.length - 1) === 304
                ) {
                  e.target.value =
                    e.target.value.slice(0, e.target.value.length - 1) + "İ";
                  setMotherName(e.target.value.toLocaleUpperCase());
                } else {
                  setMotherName(e.target.value.toLocaleUpperCase());
                }
              }}
              defaultValue={motherName}
              value={motherName}
              aria-describedby="inputGroup-sizing-lg"
              maxLength="100"
              type="text"
              required="required"
              className="form-control"
              placeholder=""
            />
          </div>
        </div>

        {
          innerTexts.id !== "ISTANBULPORTFOY" && 
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div className="input-group-prepend">
                <label className="control-label">
                  {innerTexts.label_step_one_input_relation_state}
                </label>
              </div>
              <select
                className="form-control"
                value={relationState}
                defaultValue={relationState}
                onChange={(e) => {
                  setRelationState(e.target.value);
                }}
              >
                <option>Seçiniz</option>
                <option value="E">EVLİ</option>
                <option value="B">BEKAR</option>
                <option value="D">DUL</option>
              </select>
            </div>
          </div>
        }

        <div className="col-md-12">
          <div
            style={{ display: "block" }}
            className="input-group  input-group-lg lg-12"
          >
            <div className="input-group-prepend">
              <label className="control-label">
                {innerTexts.label_step_one_input_nationality}
              </label>
            </div>
            <select
              className="form-control"
              value={nationality}
              defaultValue={nationality}
              onClick={(e) => {
                setNationality(e.target.value);
              }}
              onChange={(e) => {
                setNationality(e.target.value);
              }}
            >
              <option selected value="Türk">
                Türkiye Cumhuriyeti Vatandaşı
              </option>
            </select>
          </div>
        </div>

        {innerTexts.id !== "OPTIMUS" && innerTexts.addresVerify ? (
          <div className="col-md-12">
            <div
              style={{ display: "block" }}
              className="input-group  input-group-lg lg-12"
            >
              <div
                className="serialnu-tip"
                style={{ visibility: tipVisible ? "visible" : "hidden" }}
              >
                <h6>Yeni tip kimlik kartlarında seri nu formatı: A12345678</h6>
                <h6>Eski tip kimlik kartlarında seri nu formatı: A12A12345</h6>
              </div>
              <div
                className="input-group-prepend"
                onClick={() => setTipVisible(!tipVisible)}
              >
                <span
                  className="input-group-text"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "help",
                  }}
                >
                  <i className="fa fa-question-circle fa-lg text-danger"></i>
                </span>
                <label className="control-label">
                  {innerTexts.label_step_one_input_id_serial_nu}
                </label>
              </div>
              <input
                onChange={(e) => {
                  if (
                    e.target.value.charCodeAt(e.target.value.length - 1) ===
                      105 ||
                    e.target.value.charCodeAt(e.target.value.length - 1) === 304
                  ) {
                    e.target.value =
                      e.target.value.slice(0, e.target.value.length - 1) + "İ";
                    setIdSerialNu(e.target.value.toLocaleUpperCase());
                  } else {
                    setIdSerialNu(e.target.value.toLocaleUpperCase());
                  }
                }}
                defaultValue={idSerialNu}
                value={idSerialNu}
                aria-describedby="inputGroup-sizing-lg"
                maxLength="9"
                type="text"
                required="required"
                className="form-control"
                placeholder=""
              />
            </div>
          </div>
        ) : (
          <></>
        )
      }

        <div className="col-md-12">
          {danger.valid ? (
            <div
              style={{ marginTop: 10 }}
              className="alert alert-danger"
              role="alert"
            >
              {danger.message}
            </div>
          ) : (
            void 0
          )}
        </div>
        <div className="col-md-6">
          <button
            style={{
              marginTop: 20,
              filter: loading ? "brightness(120%)" : "",
              cursor: loading ? "no-drop" : "pointer",
            }}
            disabled={loading}
            onClick={() => {
              wizardContext.geri()
            }}
            className="btn  btn-secondr btn-lg btn-block"
          >
            {innerTexts.btn_text_back}
          </button>
        </div>
        <div className="col-md-6">
          <button
            style={{
              marginTop: 20,
              filter: (loading || isSubmitting) ? "brightness(120%)" : "",
              cursor: (loading || isSubmitting) ? "no-drop" : "pointer",
            }}
            disabled={loading || isSubmitting}
            onClick={() => {
              saveForm();
            }}
            className="btn btn-primary nextBtn pull-right btn-block btn-lg"
            type="button"
          >
            {(loading || isSubmitting) ? "Yükleniyor..." : innerTexts.btn_text_step_one}
          </button>
        </div>
      </>
    );
  };
  return (
    <div className="panel-body">
      <div className="container">
        <StepWizard>
          <Part1 portfoy={innerTexts.portfoy} handleWizard={props} />
          {
            // innerTexts.portfoy && innerTexts.id !== 'HEDEF'  && <Part2 handleWizard={props} /> TEMP: isy icin kapatildi
          }
          {innerTexts.portfoy && innerTexts.id !== 'HEDEF' && innerTexts.id !== 'ISTANBULPORTFOY'  && <Part2 handleWizard={props} />}
        </StepWizard>
      </div>
    </div>
  );
};

export default StepContextProvider(Step1);
